import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NOTIFICATION_TYPE } from '../models';

@Pipe({
  name: 'notificationTypeFormatter',
  pure: false,
})
export class NotificationTypeFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: NOTIFICATION_TYPE): string {
    if (!value) {
      return value;
    }

    let resultDate = this.getResult(value);

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(value);
    });

    return resultDate;
  }

  private getResult(type: NOTIFICATION_TYPE): string {
    return this.translateService.instant(`pipes.notification_type.${type}`);
  }
}
